// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Wrench_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M21.259 6.469a.75.75 0 0 0-1.204-.27l-3.778 3.486-1.615-.347-.347-1.615L17.8 3.945a.75.75 0 0 0-.27-1.204A6.75 6.75 0 0 0 8.25 9a6.8 6.8 0 0 0 .563 2.713l-5.645 4.88-.04.037a3 3 0 0 0 4.243 4.243l.036-.039 4.88-5.646A6.75 6.75 0 0 0 21.75 9a6.7 6.7 0 0 0-.491-2.531ZM15 14.25a5.26 5.26 0 0 1-2.538-.656.75.75 0 0 0-.93.166l-5.24 6.07a1.5 1.5 0 0 1-2.121-2.122l6.065-5.24a.75.75 0 0 0 .166-.93 5.25 5.25 0 0 1 5.47-7.717l-2.924 3.17a.75.75 0 0 0-.182.666l.53 2.468a.75.75 0 0 0 .576.576l2.47.53a.75.75 0 0 0 .666-.182l3.17-2.925A5.256 5.256 0 0 1 15 14.25Z',
  viewBox: '0 0 24 24',
  glyph: 'Wrench_Stroke2_Corner2_Rounded',
})
